// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer, Text, View } from "@components";

type Props = PropsFromLocalize;

class HelpPanelSecurity extends React.Component<Props> {
  get employeeRecordsData() {
    return [
      {
        id: "access-audit",
        label: this.props.t("ACCESS_AUDIT"),
        details: this.props.t("SECURITY_ACCESS_AUDIT_DESCRIPTION"),
      },
      {
        id: "audit-frequency",
        label: this.props.t("AUDIT_FREQUENCY"),
        details: this.props.t("SECURITY_AUDIT_FREQUENCY_DESCRIPTION"),
      },
    ];
  }

  get ipAddressData() {
    return [
      {
        id: "switch",
        label: this.props.t("ON_OFF_SWITCH"),
        details: this.props.t("SECURITY_ON_OFF_SWITCH_DESCRIPTION"),
      },
      {
        id: "adding-ip-address",
        label: this.props.t("ADDING_IP_ADDRESS"),
        details: this.props.t("SECURITY_ADDING_IP_ADDRESS_DESCRIPTION"),
      },
      {
        id: "removing-ip-address",
        label: this.props.t("REMOVING_IP_ADDRESS"),
        details: this.props.t("SECURITY_REMOVING_IP_ADDRESS_DESCRIPTION"),
      },
    ];
  }

  get emailContentData() {
    return [
      {
        id: "privacy",
        label: this.props.t("PRIVACY"),
        details: this.props.t("SECURITY_PRIVACY_DESCRIPTION"),
      },
      {
        id: "suppression",
        label: this.props.t("SUPPRESSION"),
        details: this.props.t("SECURITY_SUPPRESSION_DESCRIPTION"),
      },
      {
        id: "hyperlinks",
        label: this.props.t("HYPERLINKS"),
        details: this.props.t("SECURITY_HYPERLINKS_DESCRIPTION"),
      },
    ];
  }

  get emailDomainsData() {
    return [
      {
        id: "disabled",
        label: this.props.t("DISABLED_OFF"),
        details: this.props.t("SECURITY_DOMAIN_DISABLED_DESCRIPTION"),
      },
      {
        id: "enabled",
        label: this.props.t("ENABLED_ON"),
        details: this.props.t("SECURITY_DOMAIN_ENABLED_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <View>
        <View gap={4}>
          <Text>{this.props.t("SECURITY_INTRODUCTION")}</Text>
          <Text type="h6" className="font-weight-bold mb-1">
            {this.props.t("TUTORIAL_SECURITY_SETTINGS")}
          </Text>
        </View>
        <View margin="0 0 1rem">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.SECURITY_SETTINGS}
            title={this.props.t("SECURITY_INSTRUCTIONS")}
          />
        </View>
        <Text type="h6" className="font-weight-bold">
          {this.props.t("EMPLOYEE_RECORDS")}
        </Text>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.employeeRecordsData} />
        <Text type="h6" className="font-weight-bold">
          {this.props.t("IP_ADDRESS_RESTRICTION")}
        </Text>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.ipAddressData} />
        <Text type="h6" className="font-weight-bold">
          {this.props.t("EMAIL_CONTENT")}
        </Text>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.emailContentData} />
        <Text type="h6" className="font-weight-bold">
          {this.props.t("EMAIL_DOMAINS")}
        </Text>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.emailDomainsData} />
      </View>
    );
  }
}

export default localize()(HelpPanelSecurity);
